import type { ProcessType } from 'shared/domain/process/types/model';
import type { VisibleFieldModel } from 'shared/domain/visibleField/visibleFieldModel';
import type { HashMap } from 'shared/types/commonView';

/** Visible fields of each process; every process has a list, also an empty one. */
export function groupVisibleFieldsByProcess(
  visibleFields: VisibleFieldModel[],
  processes: ProcessType[]
): HashMap<VisibleFieldModel[]> {
  const byProcess: HashMap<VisibleFieldModel[]> = Object.fromEntries(
    processes.map((process) => [process._id, []])
  );
  visibleFields.forEach((visibleField) => {
    (byProcess[visibleField.processId] ??= []).push(visibleField);
  });
  return byProcess;
}

export function visibleFieldsOfProcess(visibleFields: VisibleFieldModel[], processId: string): VisibleFieldModel[] {
  return visibleFields.filter((visibleField) => visibleField.processId === processId);
}
